import request from '@/config/axios'

export const getWarmIntroPage = (params: any) =>
  request.get({ url: '/bosscircle/warm-intro/page', params })
export const getWarmIntro = (id: number) =>
  request.get({ url: '/bosscircle/warm-intro/get', params: { id } })
export const closeWarmIntro = (data: { id: number; version: number; reason?: string }) =>
  request.put({ url: '/bosscircle/warm-intro/close', data })
